export var AlertType;
(function (AlertType) {
    AlertType["SuccessRate"] = "SuccessRate";
    AlertType["SuccessRateQuality"] = "SuccessRateQuality";
    AlertType["Duration"] = "Duration";
    AlertType["ErrorRate"] = "ErrorRate";
})(AlertType || (AlertType = {}));
export var AlertStatus;
(function (AlertStatus) {
    AlertStatus["Alerting"] = "alerting";
    AlertStatus["Ok"] = "ok";
})(AlertStatus || (AlertStatus = {}));
export var LogLevel;
(function (LogLevel) {
    LogLevel["Info"] = "INFO";
    LogLevel["Warn"] = "WARN";
    LogLevel["Error"] = "ERROR";
    LogLevel["Debug"] = "DEBUG";
})(LogLevel || (LogLevel = {}));
export var TransactionAction;
(function (TransactionAction) {
    TransactionAction["Start"] = "START";
    TransactionAction["Finish"] = "FINISH";
})(TransactionAction || (TransactionAction = {}));
export const InternalTransactions = {
    ComponentLoad: 'PANORAMA_COMPONENT_LOAD',
    ComponentPhase: 'PANORAMA_COMPONENT_PHASE',
};
export var Platform;
(function (Platform) {
    Platform["Standalone"] = "standalone";
    Platform["BusinessManager"] = "business-manager";
    Platform["Viewer"] = "viewer";
    Platform["Editor"] = "editor";
    Platform["Mobile"] = "mobile";
})(Platform || (Platform = {}));
// This mirrors Sentry severity levels
export var ErrorSeverity;
(function (ErrorSeverity) {
    ErrorSeverity["Fatal"] = "fatal";
    ErrorSeverity["Error"] = "error";
    ErrorSeverity["Warning"] = "warning";
    ErrorSeverity["Log"] = "log";
    ErrorSeverity["Info"] = "info";
    ErrorSeverity["Debug"] = "debug";
    ErrorSeverity["Critical"] = "critical";
})(ErrorSeverity || (ErrorSeverity = {}));
//# sourceMappingURL=enum-types.js.map